<template>
  <div
    ref="container__profile"
    class="container__profile no-gutters h-100"
    style="margin-top: -1.5rem"
  >
    <div ref="container__profile-background" class="container__profile-background"></div>
    <b-col class="container__alert-resend">
      <AlertResendEmail :user-id="userId" class="component__alert-resend" />
    </b-col>
    <b-container class="pt-5 mb-5">
      <b-row class="row-profile">
        <CardUserProfile
          ref="card__profile"
          :user="user"
          :editable="true"
          class="card__profile-info card__profile col-12 col-lg-4 mb-u8"
        />

        <b-col class="col__profile-info">
          <CardUserAccountInformation
            ref="card__account-info"
            :user="user"
            :editable="true"
            :is-google-user="isGoogleUser"
            class="card__profile-info card__info mb-u8"
          />

          <CardUserBasicInformation
            ref="card__info"
            :user="user"
            :editable="true"
            class="card__profile-info card__info"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import CardUserBasicInformation from './components/CardUserBasicInformation.vue';
import CardUserProfile from './components/CardUserProfile.vue';
import CardUserAccountInformation from './components/CardUserAccountInformation.vue';
import AlertResendEmail from './components/AlertResendEmail.vue';
import Auth from '@/models/Auth';

export default {
  components: {
    CardUserBasicInformation,
    CardUserProfile,
    CardUserAccountInformation,
    AlertResendEmail
  },
  mixins: [userInfoMixin],

  data() {
    return {
      /**
       * Read once at mount, not on every render.
       *
       * Logging out nulls the Cognito session while this page is still shown,
       * and a missing token is not evidence that the account may edit its email
       * — re-reading it would flick the control back to enabled on the way out.
       * The router resolves the session before the page mounts, so it is here.
       */
      hasLinkedGoogleIdentity: Auth.hasLinkedGoogleIdentity()
    };
  },

  computed: {
    /**
     * Whether this account's email is owned by Google, so the Edit control is
     * shown disabled.
     *
     * Both checks are synchronous, so the control paints correctly on first
     * render. Asking the server instead would flip the button a moment later,
     * and the server enforces the rule regardless: the edit page withholds the
     * form and the change-request API refuses the submission.
     */
    isGoogleUser() {
      // A federated-only account. Kept because sessions rebuilt from a refresh
      // token carry no decoded ID token payload, and those are Google accounts.
      const hasGoogleUid = this.uid ? this.uid.includes('Google_') : false;

      // A linked account keeps its native uid; only the token names the link.
      return hasGoogleUid || this.hasLinkedGoogleIdentity;
    }
  }
};
</script>

<style lang="scss">
.container__alert-resend {
  display: flex;
  justify-content: center;
  margin-top: 0.25rem;
}

.component__alert-resend {
  position: absolute;
  z-index: 2;
}
.container__profile {
  .row-profile {
    z-index: -1;
  }
  .row.row-profile {
    margin: 0 !important;
  }

  .container__profile-background {
    position: absolute;
    background-color: #349ff9;
    height: 200px;
    width: 100%;
    z-index: -2;
  }
  .card__profile-info {
    z-index: 1;
  }

  .card__profile {
    padding: 0 !important;
  }
  .card__info {
    padding: 0 !important;
  }

  .container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .col__profile-info {
    padding: 0 !important;
  }

  @media screen and (max-width: 575px) {
    .container {
      padding-right: 15px !important;
      padding-left: 15px !important;
    }
  }

  @media screen and (min-width: 992px) {
    .card__profile {
      padding-right: 15px !important;
    }
    .card__info {
      padding-left: 15px !important;
    }
  }
}
</style>
